import { useMemo } from 'react';
import { createAblyClient } from '@/constants/endpoints';
import useUserStore from '@/stores/UserStore';
import * as Ably from 'ably';
import { AblyProvider } from 'ably/react';
import { Outlet } from 'react-router-dom';

import { APIClient } from '@/lib/ApiClient';

export default function AblyLayout() {
  const setClientId = useUserStore((state) => state.setClientId);
  const client = useMemo(() => {
    const apiClient = new APIClient();

    return Ably.Realtime.Promise({
      authCallback: async (tokenParams, callback) => {
        try {
          let data = {};

          // Use the existing APIClient to make the request
          if (tokenParams.clientId) {
            data = { clientId: tokenParams.clientId };
          }

          const response = await apiClient.get(createAblyClient, data, true);
          setClientId(response.clientId);

          // Call the callback with the token request
          callback(null, response);
        } catch (error) {
          console.error('Error obtaining token request:', error);
          // Call the callback with the error
          callback(error, null);
        }
      },
      autoConnect: false,
    });
  }, [setClientId]);

  return (
    <AblyProvider client={client}>
      <Outlet />
    </AblyProvider>
  );
}
